var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.2299C22 11.5572 21.9404 10.9187 21.8383 10.2971H12.217V14.1371H17.7258C17.4789 15.3972 16.7552 16.4615 15.6824 17.1852V19.7395H18.9689C20.8932 17.96 22 15.3376 22 12.2299Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.217 22.2172C14.9757 22.2172 17.2831 21.2976 18.9689 19.7395L15.6824 17.1852C14.7628 17.7982 13.5964 18.1728 12.217 18.1728C9.55203 18.1728 7.29573 16.3763 6.48686 13.9497H3.09814V16.5806C4.77547 19.9183 8.22379 22.2172 12.217 22.2172Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48682 13.9499C6.27397 13.3369 6.16328 12.6813 6.16328 12.0002C6.16328 11.319 6.28248 10.6634 6.48682 10.0504V7.41943H3.09811C2.39993 8.79876 1.99976 10.3484 1.99976 12.0002C1.99976 13.6519 2.39993 15.2016 3.09811 16.5809L6.48682 13.9499Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.217 5.82704C13.7241 5.82704 15.0693 6.34642 16.1336 7.35962L19.0455 4.44771C17.2831 2.79592 14.9757 1.78271 12.217 1.78271C8.22379 1.78271 4.77547 4.08159 3.09814 7.41922L6.48686 10.0502C7.29573 7.62357 9.55203 5.82704 12.217 5.82704Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.188f8ac0173215e9402839667c8b2833.svg";
export { ForwardRef as ReactComponent };